export const SkipContent = ({ skip_to_main_content }) => {
    return (
        <a className="skipper" href="#main">
            {skip_to_main_content}
        </a>
    );
};
